<template>
  <div style="border: 1px solid #ccc">
    <div>
      <div class="background-color-table">
        <h4>Cuadro 1</h4>
        <h4 class="subtitulo-c3">
          Ingresos y Gastos devengados año 2019 – 2020
        </h4>
      </div>

      <div class="background-color-table">
        <h4 class="subtitulo-c3">Ingresos</h4>
      </div>
      <table class="table table-striped">
        <thead>
          <tr>
            <th>Denominación</th>
            <th>{{ anio - 1 }}</th>
            <th>{{ anio }}</th>
            <th>notas</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, ingresoss) in ingresoss" :key="ingresoss">
            <td>{{ item.denominacion }}</td>
            <td>{{ item.anio_2 }}</td>
            <td>{{ item.anio_1 }}</td>
            <td>{{ item.nota }}</td>
          </tr>
        </tbody>
      </table>

      <div class="background-color-table">
        <h4 class="subtitulo-c3">Gastos</h4>
      </div>
      <table class="table table-striped">
        <thead>
          <tr>
            <th>Denominación</th>
            <th>{{ anio - 1 }}</th>
            <th>{{ anio }}</th>
            <th>notas</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, gastoss) in gastoss" :key="gastoss">
            <td>{{ item.denominacion }}</td>
            <td>{{ item.anio_2 }}</td>
            <td>{{ item.anio_1 }}</td>
            <td><input type="text" v-model="item.nota"></td>
          </tr>
        </tbody>
      </table>

      <div class="background-color-table">
        <h4 class="subtitulo-c3">Resultado</h4>
      </div>
      <table class="table table-striped">
        <thead>
          <tr>
            <th>Denominación</th>
            <th>{{ anio - 1 }}</th>
            <th>{{ anio }}</th>
            <th>notas</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in results" :key="index">
            <td>{{ item.denominacion }}</td>
            <td>{{ item.anio_2 }}</td>
            <td>{{ item.anio_1 }}</td>
            <td>{{ item.nota }}</td>
          </tr>
        </tbody>
      </table>
      <button vif="userPermissions" class="buttons" @click="guardar_notas">
        Guardar Notas
      </button>
    </div>
  </div>
</template>

<script>
// import Tabla from "../Tabla.vue";
import axios from "axios";

export default {
  props: ["state"],
  components: {
    // Tabla,
  },
  data() {
    return {
      title: "a) Resultados de la Gestión Financiera",
      dataTable: null,
      ingresos: null,
      gastos: null,
      result: null,
      gastoss: [],
      ingresoss: [],
      results: [],
      hola: "",
      anio: process.env.VUE_APP_ANIO,
      url:`${process.env.VUE_APP_RUTA_API}/instituciones/secciones_cf/${this.$route.params.idServicio}/`
    };
  },
  methods: {
    get_headers(){
      return {Authorization: `JWT ${localStorage.getItem("userToken")}`}
    },
    guardar_notas: async function() {
      var notas = []
      this.gastoss.forEach(item=>{
        if(!item.nota){return}
        console.log(item)
        notas.push({subtitulo:item.subtitulo, nota:item.nota})
      })
        await axios.put(this.url,notas,{headers:this.get_headers()})
        .then(res=>{
          console.log(res.data)
        }
          
        )
    },
    obtener_seccion (){
      var self = this
      axios.get(this.url, {params: {anio:2020, nombre:'recursos_financieros_notas'},headers:this.get_headers()})
      .then(res=>{
        var notas = res.data
        
        this.gastoss.forEach(item=>{
          var filtrado = notas.filter(nota=>{return nota.subtitulo===item.subtitulo})
          item.nota = filtrado.length>0 ? filtrado[0].nota : null
        })
        this.$forceUpdate()
        console.log(this.gastos)

      }

      )


    },
    
    obtener: async function() {
      try {
        const res = await axios.get(
          `${process.env.VUE_APP_RUTA_API}/anexos/anexo/public_list/?anexo=13&servicio=${this.$route.params.idServicio}`,
          {
            headers: {
              Authorization: `JWT ${localStorage.getItem("userToken")}`,
            },
          }
        );
        this.dataTable =
          res.data[0].datos.modificado[`${process.env.VUE_APP_ANIO}`];
        
        this.obtener_seccion()
        //Gastos
        this.gastos = this.dataTable.filter(
          (d) => d.subtitulo > 20 && d.subtitulo != 99
        );

        this.gastos.forEach((i) => {
          this.gastoss.push({
            subtitulo:i.subtitulo,
            anio_2: new Intl.NumberFormat("de-DE").format(i.anio2018),
            denominacion: i.nombre,
            anio_1: new Intl.NumberFormat("de-DE").format(i.anio2019),
          });
        });

        //Ingresos
        this.result = this.dataTable.filter((d) => d.subtitulo < 20);

        this.result.forEach((i) => {
          this.ingresoss.push({
            anio_2: new Intl.NumberFormat().format(i.anio2018),
            denominacion: i.nombre,
            anio_1: new Intl.NumberFormat().format(i.anio2019),
            notas: "",
          });
        });

        //Ingresos
        this.ingresos = this.dataTable.filter((d) => d.subtitulo == 99);

        this.ingresos.forEach((i) => {
          this.results.push({
            anio_2: new Intl.NumberFormat().format(i.anio2018),
            denominacion: i.nombre,
            anio_1: new Intl.NumberFormat().format(i.anio2019),
            notas: "",
          });
        });
      } catch (error) {
        console.log(error);
      }
    },
  },
  mounted() {
    this.obtener();
    

    if (!this.dataTable) {
      setTimeout(() =>{
      this.state = false;
      }, 10000)

    }
  },
};
</script>

<style scoped>
.subtitulo-c3 {
  font-size: 0.95rem;
  font-weight: bold;
  margin: 0;
}
.total {
  display: flex;
  justify-content: space-evenly;
}

.background-color-table {
  background-color: #f5f5f5;
  margin: 0;
}

h4 {
  text-align: center;
  font-size: 1.1rem;
  color: #2b425f;
  font-weight: bold;
  margin: 0;
}
hr {
  margin: 0;
  margin-top: 10px;
  margin-bottom: 10px;
}

table {
  font-size: 1rem !important;
  margin: 0;
  border: 1px solid #f5f5f5;
}
thead {
  background-color: #f5f5f5;
  color: #24c6ab;
  text-align: left !important;
}
tr:hover {
  background: none !important;
  text-align: left !important;
}
th {
  font-size: 1rem !important;
  text-align: left !important;
  width: 35%;
}
.table-resaltar {
  font-weight: bold;
  background: #f5f5f5;
}
.table-resaltar:hover {
  background: #f5f5f5 !important;
}
td {
  text-align: left !important;
}

.table-striped > tbody > tr:nth-child(even) > td,
.table-striped > tbody > tr:nth-child(even) > th {
  background-color: #f5f5f5;
}
.table-striped > thead > tr > th {
  background-color: #f5f5f5;
}
</style>
